import "./ItemsNeeded.css";
import React, { useEffect, useState } from "react";
import config from "../../config";
import fetchWithAuth from "../../services/fetchWithAuth";
import { ItemNeeded } from "../../Interfaces/Warehouse";

const BASE_API = config.API_BASE_URL;

// Sample data type

// Component Props
interface ItemsNeededProps {
  itemsNeeded: ItemNeeded[];
}

const ItemsNeeded: React.FC<ItemsNeededProps> = ({ itemsNeeded }) => {
  return (
    <div>
      <h2>Items Needed for Current Processing Orders</h2>
      <table className="warehouse-order-table">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Item Name</th>
            <th>Qty Needed</th>
          </tr>
        </thead>
        <tbody>
          {itemsNeeded.length > 0 ? (
            itemsNeeded.map((item: any) => (
              <tr key={item.sku}>
                <td>{item.sku}</td>
                <td>{item.product_name}</td>
                <td>{item.quantity}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className="no-items">
                No items needed.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ItemsNeeded;
